import { List, Record } from 'immutable'
import { PermissionLevel } from './enums'

export interface ISitePermission {
  readonly methods: List<string>
  readonly controller: string
  readonly value: PermissionLevel
}

const SitePermissionRecord = Record({
  controller: '',
  methods: [],
  value: '',
})

export class SitePermission extends SitePermissionRecord
  implements ISitePermission {
  public static fromJS(initialState?: any) {
    if (!initialState) {
      return new SitePermission()
    }

    const { ...rest } = initialState

    return new SitePermission({
      ...rest,
    })
  }

  public readonly methods: List<string>
  public readonly controller: string
  public readonly value: PermissionLevel

  constructor(props?: Partial<SitePermission>) {
    props ? super(props) : super()
  }
}
